<div class="dasa-chooser">
  <div class="dasa-chooser__header">
    <h2 class="dasa-chooser__title">Choose your store</h2>
    <p class="dasa-chooser__subtitle">Select the location you want to manage in this session.</p>
  </div>

  <div class="dasa-chooser__grid dasa-chooser__grid--stores">
    <article *ngFor="let data of stores; let i = index" class="dasa-store-card">
      <div class="dasa-store-card__media">
        <img class="dasa-store-card__img" [src]="FILE_STREAM_URL + data.banner" [alt]="data.name" />
      </div>
      <div class="dasa-store-card__body">
        <h6 class="dasa-store-card__name">{{ data.name }}</h6>
        <p class="dasa-store-card__address">{{ shortstoreName(data.address) }}</p>
      </div>
      <button type="button"
              class="btn btn-accent dasa-store-card__btn"
              (click)="openSelectedStore(data.id, data.latitude, data.longitude)">
        Choose store <i class="fa-solid fa-arrow-right ms-1"></i>
      </button>
    </article>
  </div>
</div>
